(ns app.components.cards.views
  (:require-macros)
  (:require ["react-dnd" :refer (useDrag)]
            [app.components.buttons.views :as buttons]
            [app.components.cards.styles :refer [activity-card-movement-down-style
                                                 activity-card-movement-up-style activity-card-side-note-style
                                                 activity-card-style arrow-down arrow-up create-product-card-style image-container
                                                 new-card-style product-card-style product-image product-info-container]]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [arrow-down-icon arrow-up-icon
                                                form-icon plus-grey-icon
                                                product-icon]]
            [app.components.input-field.views :refer [label-text-field]]
            [app.components.menus.views :refer [project-card-ellipsis-menu
                                                workpaces-menu]]
            [app.dashboard.events :as wevents]
            [app.events :as events]
            [clojure.string :as s]
            [moment]
            [re-com.core :as re-com :refer [at box h-box v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent-mui.material.tooltip  :refer [tooltip]]
            [reagent.core   :as    reagent]))

(defn template-card [{:keys [image name color]}]
  [v-box
   :src (at)
   :gap "12px"
   :children [[:div    {:style {:background "#FC7E92" :width "239.5px" :height "160px" :border-radius "8px"}}]
              [header {:label "Customer engagement" :type :large :size :semibold}]]])

(defn new-card [{:keys [label onClick]}]
  [v-box
   :src (at)
   :gap "12px"
   :children [[:div    {:class (new-card-style)
                        :onClick onClick}
               [plus-grey-icon]]
              [header {:label label :type :large :size :semibold}]]])

(defn create-product-card [{:keys [label workspace-id workspace-data]}]
  (let [hover? (reagent/atom false)
        show-workspaces-menu? (reagent/atom false)]
    [v-box
     :src (at)
     :gap "12px"
     :children  [[:div
                  {:id (str "create-menu-for-" label)
                   :onClick #(swap! show-workspaces-menu? not) 
                   :class (create-product-card-style)}
                  [plus-grey-icon]]
                 [tooltip {:title (str "Create new " label)
                           :arrow false
                           :placement "top-start"}
                  [:div {:style {:padding-left "5px"}} [header {:label label  :type :normal :size  :semibold}]]]
                 (when show-workspaces-menu? [workpaces-menu
                                               {:menu-id (reagent/atom (str "create-menu-for-" label))
                                                :show-workspaces-menu? show-workspaces-menu?
                                                :workspace-id workspace-id
                                                :workspace-data workspace-data
                                                :type label
                                                :action (reagent/atom :create)}])
                 ]]))

(defn time-ago [date]
  (if (nil? date) "" (.fromNow (moment date))))

(defn drag-component [children data-id card-type selected-folder-id]
  (let [dragging-values (useDrag (fn []
                                   #js {:type "any"
                                        :item (fn [] #js{:id data-id :type "card" :card (clj->js card-type) :selected-folder-id selected-folder-id})
                                        :end (fn [item ^js/monitor monitor]
                                               (when (and (not (nil? (.-id item))) (not (nil? (.getDropResult monitor))))
                                                 (if (= "product" (:card (js->clj item :keywordize-keys true)))
                                                   (re-posh/dispatch [::wevents/move-product  {:folder-id selected-folder-id :product-id (.-id item) :destination-folder-id (:workspace_id (.-identifier (.getDropResult monitor)))}])
                                                   (re-posh/dispatch [::wevents/move-form {:folder-id selected-folder-id :form-id (.-id item) :destination-folder-id (:workspace_id (.-identifier (.getDropResult monitor)))}]))))
                                        :collect (fn [^js/monitor monitor]
                                                   #js{:isDragging (.isDragging monitor)
                                                       :item (.getItem monitor)})}))
        dragRef (second (js->clj dragging-values))]
    [:div {:id (str "drag-card-" data-id)
           :ref dragRef} children]))

(defn product-card [{:keys [product-form-name thumbnail onClick onChange label-clicked-out? product-form-id link show-workspaces-menu? copyLink type workspace-id selected-folder-id showing-settings? sent-value last-updated product-form-secondary-id product-description action in-workspace menu-id product-form-array assets-selected delete-notification show-ellipsis-menu? folder-id]}]
  (let [text-val (reagent/atom product-form-name)
        hover? (reagent/atom false)] 
    (fn []
      [:f> drag-component
       [v-box
        :src (at)
        :class (product-card-style)
        :children [[box
                    :class (image-container)
                    :child (if-not (nil? thumbnail)
                             [:img {:src thumbnail :width "100%" :height "164px"
                                    :class (product-image)}] (if (= type :product) [product-icon] [form-icon]))
                    :attr {:on-click onClick}]
                   [h-box
                    :align :center
                    :gap "5px"
                    :class (product-info-container)
                    :children [[v-box
                                :children [[label-text-field {:placeholder "Untitled" :disable false :value text-val
                                                              :onChange #(do (reset! text-val %)
                                                                             (onChange @text-val))
                                                              :focused? true
                                                              :id "product-card-name"
                                                              :name product-form-name
                                                              :padding "0px 12px"
                                                              :text-val text-val
                                                              :width "100px"
                                                              :label-clicked-out? label-clicked-out?
                                                              :selected true}]
                                           [h-box
                                            :align :center
                                            :children [(when-not (nil? in-workspace)
                                                         [h-box
                                                          :align :center
                                                          :justify :start
                                                          :children [[buttons/button
                                                                      {:action :cta :type :tertiary
                                                                       :title in-workspace :size :small :style {:text-decoration "none" :padding "0px 12px"}
                                                                       :onClick #(re-frame/dispatch [::events/navigate [:folder-view :folder-id folder-id :id workspace-id]])}]]])
                                                       [header {:label  (when-not (nil? last-updated) (str "Updated " (time-ago last-updated)))
                                                                :type :small
                                                                :size :regular
                                                                :style {:padding "0px 12px" :color "#605D65"}}]]]]]
                               (when (and show-ellipsis-menu? (or @show-workspaces-menu? @hover?))
                                 [project-card-ellipsis-menu menu-id link label-clicked-out? show-workspaces-menu? copyLink type workspace-id selected-folder-id product-form-id showing-settings? product-form-name product-form-secondary-id product-description action product-form-array assets-selected])]]]
        :attr     {:on-mouse-over #(do
                                     (reset! hover? true))
                   :on-mouse-out  #(do
                                     (reset! hover? false))
                   :on-key-up (fn [^js/Event e]
                                (when (= (-> e .-which) 32)
                                  (.preventDefault e)))}] product-form-id type selected-folder-id])))



(defn activity-card [{:keys [label  main-statistic-num statistic-change movement]}]
  [v-box
   :style {:background-color "white"}

   :class (activity-card-style)
   :children (if-not (= main-statistic-num "N/A")
               [[header {:label label :type :large :size :regular}]
                [header {:label main-statistic-num :type :x-large :size :bold}]
                [h-box
                 :align :center
                 :gap "2px"
                 :children
                 [(if (pos? movement)
                    [arrow-up-icon {:class (arrow-up)}]
                    [arrow-down-icon {:class (arrow-down)}])
                  [:span {:class (if (pos? movement)
                                   (activity-card-movement-up-style)
                                   (activity-card-movement-down-style))} statistic-change]
                  [:span {:class (activity-card-side-note-style)} "vs. previous 7 days"]]]]
               [[header {:label label :type :large :size :regular}]
                [header {:label (if (s/includes? label "rate")
                                  main-statistic-num
                                  "0")
                         :type :x-large :size :bold
                         :style {:color "#CACBCC"}}]])])
